import * as React from 'react';
import * as _ from 'underscore';

import { BodyCell, DataGrid } from '@tableau/data-grid-3-wrapper';
import { Messages } from '../../../codegen/Localize';
import { CommonStyles } from '../../../common/react/CommonStyles';
import { FeatureFlags } from '../../../ts/FeatureFlags';
import { SiteRolesHelper } from '../../../ts/helpers/SiteRolesHelper';
import { IGroupInfo } from '../../../ts/models/IGroupInfo';
import { GrantLicenseModes } from '../../../ts/ServerApi/requests/SyncActiveDirectoryGroupRequest';
import { SiteRoles } from '../../../ts/ServerApi/types/ISiteRole';
import { DataGridProfilePicture } from '../../content/DataGridProfilePicture';
import { ProfilePictureStyles } from '../../content/styles/ProfilePictureStyles';
import { DataGridCells } from '../ListView/DataGridCells';
import { CenterAlignedCell, StyledCellFormatter } from '../ListView/StyledCellWrapper';

export namespace GroupDataGridCells {

  export function ProfilePictureCell(
      getProfileProps: (row: DataGrid.Row) => DataGridProfilePicture.Props,
      getLinkOptions: (row: DataGrid.Row) => DataGridCells.ILink
    ): React.StatelessComponent<BodyCell.Props> {
    return StyledCellFormatter(function ProfilePictureCells(props: BodyCell.Props) {
      const linkOptions = getLinkOptions(props.row);
      return (
        <div style={ProfilePictureStyles.Layout.GroupNameWithProfilePictureCellWrapperStyle}>
          <span style={ProfilePictureStyles.Layout.GroupNameWithProfilePictureCellChildStyle}>
            <DataGridProfilePicture {...getProfileProps(props.row)} />
          </span>
          <span style={ProfilePictureStyles.Layout.GroupNameWithProfilePictureCellChildDisplayNameStyle}>
            <span data-tb-test-id={linkOptions.testId} style={CommonStyles.Layout.FlexBlockLeftAndCenter}>
              {DataGridCells.getLinkMarkup(linkOptions, props.row)}
            </span>
          </span>
        </div>
      );
    });
  }

  export function MinimumSiteRoleCell(): React.StatelessComponent<BodyCell.Props> {
    return CenterAlignedCell(function generateSiteRoleName(props: BodyCell.Props) {
      const group = props.row.data as IGroupInfo;
      let siteRole: string = group.minimumSiteRole ? SiteRolesHelper.siteRoleToName(group.minimumSiteRole) : '';
      if (FeatureFlags.licenseUponLoginEnabled && group
          && (group.grantLicenseMode === undefined || group.grantLicenseMode !== GrantLicenseModes.ON_LOGIN)
          && (group.domainName === undefined || group.domainName === 'local')) {
          siteRole = '';
      }
      return (
        <div>{siteRole}</div>
      );
    });
  }
}
